import '@fortawesome/fontawesome-pro/css/all.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'locale/i18n';

import sentryReportInit from 'utils/sentryReports';
import AppWrappers from 'components/appWrappers/AppWrappers';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import reportWebVitals from './reportWebVitals';

sentryReportInit();

ReactDOM.render(
  <React.StrictMode>
    <AppWrappers>
      <App />
    </AppWrappers>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
